export default "__VITE_ASSET__DBfd5Bhr__"